import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from '@mui/material';
import { Edit } from '@mui/icons-material';

function EmployeeStipendTable({ stipendData, onEditStipend }) {
  if (!stipendData || !Array.isArray(stipendData.stipends) || stipendData.stipends.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', padding: 2 }}>
        No stipend history available.
      </Box>
    );
  }

  return (
    <TableContainer component={Paper} elevation={1}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: '#212529', color: 'white' }}>
            <TableCell sx={{ fontWeight: 'bold', color: 'white', textAlign: 'center' }}>
              Sr. No.
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold', color: 'white', textAlign: 'center' }}>
              Stipend Amount
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold', color: 'white', textAlign: 'center' }}>
              Effective From
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold', color: 'white', textAlign: 'center' }}>
              Action
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {stipendData.stipends.map((item, index) => (
            <TableRow key={item.id} hover>
              <TableCell sx={{ textAlign: 'center' }}>{index + 1}</TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                ₹ {Math.round(Number(item.stipend_amount)).toLocaleString('en-IN')}
              </TableCell>
              <TableCell sx={{ textAlign: 'center' }}>{item.effective_from_date}</TableCell>
              <TableCell sx={{ textAlign: 'center' }}>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => onEditStipend && onEditStipend(item)}
                  startIcon={<Edit sx={{ width: 18, height: 18 }} />}
                >
                  Edit
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default EmployeeStipendTable;

